Vue.component('hoshitori-table', {
  props: {
    games: {
      type: Array,
      default: () => {
        return []
      },
    },
    teams: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  template: `

<div>
  <div class="table-container">
    <table class="hoshitori-table table is-striped is-fullwidth">
      <thead>
        <tr>
          <th>チーム名</th>
          <th v-for="team in teams" :key="team._id"><span :title="team.shortName">{{ team.shortName }}</span></th>
          <th class="has-text-centered">勝点</th>
          <th class="has-text-centered">得失点</th>
          <th class="has-text-centered">得点</th>
          <th class="has-text-centered">失点</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="team in teams" :key="team._id">
          <th>{{ team.shortName }}</th>
          <td v-for="opponent in teams" :key="team._id + '-' + opponent._id" :class="{ 'has-background-light': team._id === opponent._id }">
            <template v-if="team._id !== opponent._id">
              <div class="has-text-centered" v-for="(item, i) in hoshitoriData[team._id]?.directMatch[opponent._id]" :key="i"><a href="#" @click.stop.prevent="showGameDetail(item.game)">{{ item.result }}</a></div>
            </template>
            <template v-else="v-else">-</template>
          </td>
          <td>{{ team.rankingData.point }}</td>
          <td>{{ team.rankingData.goalDifferential }}</td>
          <td>{{ team.rankingData.score }}</td>
          <td>{{ team.rankingData.score - team.rankingData.goalDifferential }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>`,
  computed: {
    hoshitoriData() {
      const result = this.teams.reduce((acc, team) => {
        return {
          ...acc,
          [team._id]: {
            ...team.rankingData,
            directMatch: this.teams.reduce((acc, team) => ({ ...acc, [team._id]: [] }), {}),
          },
        }
      }, {})

      this.games.forEach((game) => {
        if (!game.gameOver) {
          return
        }

        const a = game.gameRecords[0]
        const b = game.gameRecords[1]

        if (a.point === b.point) {
          // 引き分け
          result[a.team._id].directMatch[b.team._id].push({
            result: `${a.score || 0}△${b.score || 0}`,
            game,
          })
          result[b.team._id].directMatch[a.team._id].push({
            result: `${b.score || 0}△${a.score || 0}`,
            game,
          })
        } else if (parseInt(a.point) > parseInt(b.point)) {
          // Aの勝ち
          result[a.team._id].directMatch[b.team._id].push({
            result: `${a.score || 0}○${b.score || 0}`,
            game,
          })
          result[b.team._id].directMatch[a.team._id].push({
            result: `${b.score || 0}●${a.score || 0}`,
            game,
          })
        } else {
          // Bの勝ち
          result[a.team._id].directMatch[b.team._id].push({
            result: `${a.score || 0}●${b.score || 0}`,
            game,
          })
          result[b.team._id].directMatch[a.team._id].push({
            result: `${b.score || 0}○${a.score || 0}`,
            game,
          })
        }
      })

      return result
    },
  },
  methods: {
    showGameDetail(game) {
      if (game) {
        this.$emit('show-game-detail', game)
      }
    }
  },
})
